// src/components/blog/BlogDetailWrapper.tsx
import React from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import { Blog } from "../../services/blog/GetPublicBlogs";
import BlogDetail from "./BlogDetail";

const BlogDetailWrapper: React.FC<{ blogs: Blog[] }> = ({ blogs }) => {
  const { slug } = useParams();
  const location = useLocation();
  const state = location.state as Blog | undefined;

  const blog =
    state || blogs.find((b) => b.title.replace(/\s+/g, "-") === slug);

  // Si no se encuentra el blog, redirigir a la sección de blogs
  if (!blog) {
    return <Navigate to="/blogs" replace />;
  }

  return (
    <section className="blog-detail-wrapper">
      <BlogDetail />
    </section>
  );
};

export default BlogDetailWrapper;
